import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    console.log("InfoPanel controller connected");
    this.isPanelLocked = false;
  }

  showOnHover(event) {
    console.log("showOnHover called", event.detail);
    if (!this.isPanelLocked) {
      this.show(event.detail, false);
    }
  }

  showOnClick(event) {
    console.log("showOnClick called", event.detail);
    this.isPanelLocked = true;
    this.show(event.detail, true);
  }

  show(data, locked) {
    console.log("Showing panel with data:", data);
    const html = `
            <div class="bg-white p-4 rounded-lg shadow-lg border border-blue/20 min-w-[200px]">
                <div class="flex justify-between items-start mb-3">
                    <h3 class="text-lg font-bold text-blue">${data.name || 'Sans nom'}</h3>
                    <button class="text-gray-400 hover:text-blue transition-colors duration-200 px-2"
                            data-action="click->info-panel#toggleLock">
                        ${locked ? '🔒' : '🔓'}
                    </button>
                </div>
                <p class="text-gray-600 mb-2">${data.description || 'Aucune description'}</p>
                ${data.price ? `
                    <p class="mt-3 text-lg font-bold text-blue">
                        ${data.price}€ <span class="text-sm text-gray-500">/ nuit</span>
                    </p>` : ''}
            </div>
        `;

    this.panelTarget.innerHTML = html;
    this.panelTarget.classList.remove('hidden');
    this.panelTarget.style.border = '2px solid red';
  }

  hide() {
    console.log("hide called");
    if (!this.isPanelLocked) {
      this.panelTarget.classList.add('hidden');
    }
  }

  toggleLock() {
    console.log("toggleLock called");
    this.isPanelLocked = !this.isPanelLocked;
    const lockButton = this.panelTarget.querySelector('button');
    if (lockButton) {
      lockButton.textContent = this.isPanelLocked ? '🔒' : '🔓';
    }
  }
}
